module.exports = __webpack_public_path__ + "img/radarmeteo-marchio.b8c04542.png";